import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class TutorialService {

  constructor(
    private http: HttpClient
  ) { }

  getTutorials(queryParams: any) {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    const payload = JSON.stringify({}) + timestamp;

    const signature = CryptoJS.HmacSHA256(
      payload,
      environment.BROKER_HMAC_SECRET
    ).toString(CryptoJS.enc.Hex);

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-signature": signature,
      "x-timestamp": timestamp,
      "ngrok-skip-browser-warning": "true",
    });

    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.BROKER_PANEL_URL + urls.TUTORIALS, { headers, params })
      .pipe(catchError(errorHandl));
  }
}
